'use client';

import { CheckMarkIcon, CloseIcon, CopyIcon } from '@insta-club/components';
import { t } from '@insta-club/translations';
import { copyToClipboard } from '@insta-club/utilities';

interface Props {
    title: string;
    description: string;
    copyable: string;
}

const AwardBox: React.FC<Props> = ({ title, description, copyable }) => {
    return (
        <div className='shadow-card rounded-2xl border border-gray-200 bg-white px-6 py-3'>
            <div className='mb-2 flex flex-wrap items-center gap-1'>
                <div className='flex flex-1 items-center gap-1'>
                    <div className='bg-primary-50 flex h-8 w-8 items-center justify-center rounded-full'>
                        <div className='bg-primary-500 flex h-6 w-6 items-center justify-center rounded-full'>
                            <CheckMarkIcon className='text-white' />
                        </div>
                    </div>
                    <p className='text-base font-bold text-gray-900'>{title}</p>
                </div>
                <CloseIcon className='cursor-pointer text-gray-400' />
            </div>
            <p className='text-sm text-gray-400'>{description}</p>
            <div className='mt-4 flex items-center rounded-xl border border-gray-100 bg-gray-50 px-4 py-2'>
                <p className='relative top-0.5 flex-1 truncate text-gray-700'>{copyable}</p>
                <div
                    onClick={() => copyToClipboard(copyable)}
                    className='text-primary-500 flex cursor-pointer items-center gap-1'
                >
                    <CopyIcon />
                    <span>{t('copy')}</span>
                </div>
            </div>
        </div>
    );
};

export default AwardBox;

